import axios from "axios";
import { Link } from "@/interfaces/Link";

const apiBaseUrl =
  process.env.NODE_ENV === "development"
    ? "https://nederlands-mijnmuseum.local/"
    : "/";

export default {
  async searchTerm(
    searchterm: string
  ): Promise<{ page: Link[]; post: Link[]; agenda: Link[] }> {
    const { data } = await axios.post(`${apiBaseUrl}`, {
      search: searchterm,
    });

    return data;
  },
};
